<template>
  <div>
    <b-nav-item-dropdown
      class="dropdown-notification mr-75"
      menu-class="dropdown-menu-media dropdown-menu-right"
      left
      v-b-tooltip.hover.button.viewport="`${$t('action_plan.tasks')}`"
    >
      <template #button-content>
        <feather-icon
          :badge="filteredNotifications.length"
          badge-classes="bg-danger"
          class="text-body"
          icon="CheckSquareIcon"
          size="21"
        />
      </template>

      <li class="dropdown-menu-header">
        <div class="dropdown-header d-flex justify-content-between align-items-center">
          <h4 class="notification-title mb-0">
            {{ $t("action_plan.tasks") }}
          </h4>
          <b-badge pill variant="light-primary">
            {{ `${filteredNotifications.length}` }}
          </b-badge>
        </div>
      </li>

      <vue-perfect-scrollbar
        class="scrollable-container media-list scroll-area"
        tagname="li"
        :settings="perfectScrollbarSettings"
      >
        <div
          v-for="(notification, index) in filteredNotifications"
          :key="index"
          class="cursor-pointer"
          draggable="true"
          @dragstart="onDragStart($event, notification)"
          @dragend="onDragEnd"
          @click="handleClick(notification, $event)"
        >
          <b-media>
            <template #aside>
              <b-avatar
                size="32"
                :text="getAvatarNotificaction(notification)"
              >
              </b-avatar>
            </template>
            <p class="media-heading d-flex align-items-center">
              <span v-if="notification.type === 'recording_request_validate'" class="font-weight-bolder flex-grow-1">
                Validar Petición de Grabación
              </span>
              <span v-if="notification.type === 'recording_request_reopened'" class="font-weight-bolder flex-grow-1">
                Petición de Grabación Reasiganda
              </span>
              <span v-if="notification.type === 'crisis_validate'" class="font-weight-bolder flex-grow-1">
                Validar Formulario de Crisis
              </span>
              <span v-if="notification.type === 'crisis_reopened'" class="font-weight-bolder flex-grow-1">
                Formulario de Crisis Reasignado
              </span>
              <span v-if="notification.type === 'training_validate'" class="font-weight-bolder flex-grow-1">
                Validar Capacitación
              </span>
              <span v-if="notification.type === 'training_reopened'" class="font-weight-bolder flex-grow-1">
                Capacitación reabierta
              </span>
              <span v-if="notification.type === 'penetration_testing_validate'" class="font-weight-bolder flex-grow-1">
                Validar Prueba de penetración
              </span>
              <span v-if="notification.type === 'penetration_testing_reopened'" class="font-weight-bolder flex-grow-1">
                Prueba de penetración reabierta
              </span>
              <span v-if="notification.type === 'security_box_testing_validate'" class="font-weight-bolder flex-grow-1">
                Validar Prueba de Caja de Seguridad
              </span>
              <span v-if="notification.type === 'security_box_testing_reopened'" class="font-weight-bolder flex-grow-1">
                Prueba de caja de seguridad reabierta
              </span>
              <span v-if="notification.type === 'user_view_validate'" class="font-weight-bolder flex-grow-1">
                Validar vista
              </span>
              <span v-if="notification.type === 'video_tour_validate'" class="font-weight-bolder flex-grow-1">
                Validar video tour
              </span>
              <span v-if="notification.type === 'user_view_commented'" class="font-weight-bolder flex-grow-1">
                Comentario realizado en validación de vista
              </span>
              <span v-if="notification.type === 'user_view_was_validated'" class="font-weight-bolder flex-grow-1">
                Vista validada
              </span>
              <span v-if="notification.type === 'video_tour_was_validated'" class="font-weight-bolder flex-grow-1">
                Video Tour validado
              </span>
              <span v-if="notification.type === 'video_tour_commented'" class="font-weight-bolder flex-grow-1">
                Comentario realizado en validación de video tour
              </span>
              <span v-if="notification.type === 'external_personnel_reminder'" class="font-weight-bolder flex-grow-1">
                Recordatorio de dispositivo en mantenimiento
              </span>
              <span v-if="(notification.type === 'operational_security_form_validation' || notification.type === 'significant_event_pending_comment') && notification.action_plan">
                <div class="text-truncate" style="margin-bottom: 2px;">{{ getActionPlanName(notification) }}</div>
                <div style="margin-bottom: 2px;">
                  {{ notification.action_plan.reference }}
                </div>
                <div>
                  <feather-icon icon="CalendarIcon" size="12" style="vertical-align: baseline; display: inline-block; margin-right: 2px !important;" />
                  fecha: {{ notification.action_plan.formValidationData.status_date }}
                </div>
                <!--<div>
                  {{ notification.status }}
                </div>-->
              </span>
              <span v-else class="font-weight-bolder flex-grow-1">
                <div>{{ getActionPlanName(notification) }}</div>
                <div
                  v-if="notification.type === 'unit_task' && notification.taskData && notification.taskData.subject && notification.taskData.comment"
                  class="font-weight-normal"
                  style="margin-top: 2px;"
                >
                  {{ notification.taskData.comment }}
                </div>
                <div v-if="(notification.type === 'operational_procedure' || notification.type === 'risk' || notification.type === 'simulacrum' || notification.type === 'bau_complement' || notification.type === 'policy_exception' || notification.type === 'security_self_audit' || notification.type === 'planning' || notification.type === 'planning_released_form' || notification.type === 'unit_task') && notification.statusDate" class="font-weight-normal" style="margin-top: 2px;">
                  <feather-icon icon="CalendarIcon" size="12" style="vertical-align: baseline; display: inline-block; margin-right: 2px !important;" />
                  fecha: {{ notification.statusDate }}
                </div>
              </span>
              <b-button
                v-if="isPanelFailureNotification(notification)"
                size="sm"
                variant="outline-success"
                class="ml-1"
                @click.stop="completePanelFailureNotification(notification)"
              >
                {{ $t('unit.mark_as_done') }}
              </b-button>
              <b-button
                v-if="notification.type === 'risk' && isFinalRisk(notification)"
                size="sm"
                variant="outline-danger"
                class="ml-1"
                @click.stop="removeRiskNotification(notification)"
              >
                {{ $t('risk.remove_notification') }}
              </b-button>
              <b-button
                v-if="notification.type === 'simulacrum' && isFinalSimulacrum(notification)"
                size="sm"
                variant="outline-danger"
                class="ml-1"
                @click.stop="removeSimulacrumNotification(notification)"
              >
                {{ $t('risk.remove_notification') }}
              </b-button>
              <b-button
                v-if="notification.type === 'bau_complement' && isFinalBauComplement(notification)"
                size="sm"
                variant="outline-danger"
                class="ml-1"
                @click.stop="removeBauComplementNotification(notification)"
              >
                {{ $t('risk.remove_notification') }}
              </b-button>
              <b-button
                v-if="notification.type === 'operational_procedure' && isFinalOperationalProcedure(notification)"
                size="sm"
                variant="outline-danger"
                class="ml-1"
                @click.stop="removeOperationalProcedureNotification(notification)"
              >
                {{ $t('risk.remove_notification') }}
              </b-button>
              <b-button
                v-if="notification.type === 'security_self_audit' && isFinalSecuritySelfAudit(notification)"
                size="sm"
                variant="outline-danger"
                class="ml-1"
                @click.stop="removeSecuritySelfAuditNotification(notification)"
              >
                {{ $t('risk.remove_notification') }}
              </b-button>
              <b-button
                v-if="notification.type === 'policy_exception' && isFinalPolicyException(notification)"
                size="sm"
                variant="outline-danger"
                class="ml-1"
                @click.stop="removePolicyExceptionNotification(notification)"
              >
                {{ $t('risk.remove_notification') }}
              </b-button>
            </p>
            <div v-if="notification.type === 'user_view_validate' || notification.type === 'video_tour_validate' || notification.type === 'user_view_was_validated' || notification.type === 'video_tour_was_validated'">
              <p class="notification-text mb-0">
                {{ notification.name }}
              </p>
             <!--  <p class="notification-text mb-0">
                {{ notification.user.user }}
              </p> -->
            </div>
            <div v-if="notification.type === 'recording_request_validate' || notification.type === 'recording_request_reopened'">
              <p class="mb-0">
                {{ notification.request.reference_number }}
              </p>
              <p class="mb-0">
                <feather-icon icon="CalendarIcon" size="13" />
                Fecha: {{ notification.type === 'recording_request_validate' ? dateFormatedSecurityBox(notification.request.created) : dateFormatedSecurityBox(notification.created_at) }}
              </p>
            </div>
            <div v-if="notification.type === 'crisis_validate'">
              <p class="mb-0">
                {{ notification.crisis.reference_number }}
              </p>
              <p class="mb-0">
                <feather-icon icon="CalendarIcon" size="13" />
                Fecha: {{ notification.created_at }}
              </p>
            </div>
            <div v-if="notification.type === 'crisis_reopened'">
              <p class="mb-0">
                {{ notification.crisis.reference_number}}
              </p>
              <p class="mb-0">
                <feather-icon icon="CalendarIcon" size="13" />
                Fecha: {{ notification.crisis.last_status.reopened_at }}
              </p>
            </div>
            <div v-if="notification.type === 'training_validate'">
              <p class="mb-0">
                {{ notification.training.reference_number }}
              </p>
              <p class="mb-0">
                <feather-icon icon="CalendarIcon" size="13" />
                Fecha: {{ dateFormatedSecurityBox(notification.training.registration_date) }}
              </p>
            </div>
            <div v-if="notification.type === 'training_reopened'">
              <p class="mb-0">
                {{ notification.training.reference_number}}
              </p>
              <p class="mb-0">
                <feather-icon icon="CalendarIcon" size="13" />
                Fecha: {{ notification.training.last_status.reopened_at }}
              </p>
            </div>
            <div v-if="notification.type === 'penetration_testing_validate' || notification.type === 'security_box_testing_validate'">
              <p class="mb-0">
                {{ (notification.type === 'penetration_testing_validate') ? notification.penetration_testing.reference_number : notification.security_box_testing.reference_number }}
              </p>
              <p class="mb-0">
                <feather-icon icon="CalendarIcon" size="13" />
                Fecha: {{ (notification.type === 'penetration_testing_validate') ? dateFormatedSecurityBox(notification.penetration_testing.registration_date) : dateFormatedSecurityBox(notification.security_box_testing.registration_date) }}
              </p>
            </div>
            <div v-if="notification.type === 'penetration_testing_reopened'">
              <p class="mb-0">
                {{ notification.penetration_testing.reference_number}}
              </p>
              <p class="mb-0">
                <feather-icon icon="CalendarIcon" size="13" />
                Fecha: {{ notification.penetration_testing.last_status.reopened_at }}
              </p>
            </div>
           <div v-if="notification.type === 'security_box_testing_reopened'">
              <p class="mb-0">
                {{ notification.security_box_testing.reference_number }}
              </p>
              <p class="mb-0">
                <feather-icon icon="CalendarIcon" size="13" />
                Fecha: {{ notification.security_box_testing.last_status.reopened_at }}
              </p>
              <p class="notification-text mb-0">
                {{ notification.user.user }}
              </p>
            </div>
           <div v-if="notification.type === 'external_personnel_reminder'">
              <p class="mb-0">
                Dispositivo: {{ notification.device_name }}
              </p>
              <div class="text-right">
                <b-button size="sm" variant="info" @click="goToExternalPersonnelAccessControlView(notification)">
                  Ver dispositivo
                  <feather-icon icon="ArrowRightIcon" size="13" />
                </b-button>
              </div>
            </div>
            <div v-else-if="notification.type === 'user_view_commented'">
              <p class="notification-text mb-0">
                {{ notification.name }}
              </p>
              <p class="notification-text mb-0">
                {{ notification.user.user }}
              </p>
            </div>
            <small v-else class="notification-text">
              {{ notification.description || (notification.user && notification.user.user) || '' }}
            </small>
            <span v-if="notification.completed" class="notification-text ml-1 font-italic">(Completada)</span>
            <div v-if="notification.id_action_plan && getNotificationDeadline(notification)" class="mt-1 deadline-container">
              <b-badge
                :id="`deadline-notification-${notification.id || notification.uuid_action_plan_log || notification.id_action_plan}`"
                v-b-tooltip.hover
                :title="getDeadlineTooltip(getNotificationDeadline(notification))"
                variant="light-primary"
                class="deadline-badge"
              >
              <div class="d-flex align-items-center">
                <feather-icon icon="CalendarIcon" size="13" class="deadline-icon" />
                <span class="d-flex-inline align-items-start">
                  <span class="font-weight-bold">{{ $t('action_plan.deadline') }}:</span>
                  <span class="font-weight-bold ml-1">{{ formatDeadlineDate(getNotificationDeadline(notification)) }}</span>
                </span>
              </div>
              <div class="d-flex align-items-center">
                <span :class="getDeadlineIconClass(getNotificationDeadline(notification))">
                  <feather-icon icon="AlertTriangleIcon" size="14" class="deadline-icon" />
                </span>
                <span v-if="getDeadlineText(getNotificationDeadline(notification))" class="font-weight-bold">
                  ({{ getDeadlineText(getNotificationDeadline(notification)) }})
                </span>
              </div>
              </b-badge>
            </div>
          </b-media>
        </div>
      </vue-perfect-scrollbar>
    </b-nav-item-dropdown>

    <!-- Modal para ver tarea asignada -->
    <view-assigned-task-modal
      modal-id="view-assigned-task-modal"
      :task="selectedTask"
      @task-updated="handleTaskUpdated"
      @open-task-alarm="openTaskAlarm"
    />

    <validate-view-modal
      :user-view="userViewSelected"
      :show-modal-user-views="showModalUserViews"
      @open-view-modal="openViewModal"
      @set-current-preview="setCurrentPreview"
      @user-view-commented="removeUserViewNotification"
      @user-view-validated="removeUserViewNotification"
      @update:isActive="showModalUserViews = false"
    />

    <views-modal
      :current-preview-selected="currentPreviewSelected"
      :item="userViewData"
      :show-modal="showViewModal"
      @clean-item="currentPreviewSelected = null"
      @refresh="removeUserViewNotification"
      @update:isActive="showViewModal = false"
    />

    <user-view-validated-modal
      :user-view="userViewSelected"
      :show-user-view-validated-modal="showUserViewValidatedModal"
      @update:isActive="closeUserViewValidatedModal()"
    />

    <validate-video-tour-modal
      :video-tour="videTourSelected"
      :show-modal-video-tour="showModalVideoTour"
      @open-video-tour-modal="openVideoTourModal"
      @set-current-preview="setCurrentPreview"
      @video-tour-commented="removeUserViewNotification"
      @video-tour-rejected="removeUserViewNotification"
      @video-tour-validated="removeUserViewNotification"
      @update:isActive="showModalVideoTour = false"
    />

    <video-tour-modal
      ref="videoTourModalForm"
      :isEdit="true"
      :currentItemToEdit="userVideoTourData"
    />

    <video-tour-validated-modal
      :video-tour="videTourSelected"
      :show-video-tour-validated-modal="showVideoTourValidatedModal"
      @update:isActive="closeVideoTourValidatedModal()"
    />
  </div>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
  VBTooltip,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import {BModal} from "bootstrap-vue";
import vSelect from "vue-select";
import {
  computed,
  onMounted,
  onUnmounted,
  ref,
  getCurrentInstance,
  nextTick
} from "@vue/composition-api";
import {useUtils as useI18nUtils} from "@core/libs/i18n";
import {useToast} from "vue-toastification/composition";
import useActionPlan from "@/composables/mainSearch/useActionPlan";
import {EventBus} from "@/libs/event-bus";
import {SLOT_TYPES, SOURCES} from "@/config/layoutConfig";
import axios from "@/libs/axios";
import action_plan from "@/store/tenant/action_plan";
import ability from "@/libs/acl/ability";
import ViewAssignedTaskModal from "@/views/unit/ViewAssignedTaskModal.vue";
import moment from "moment-timezone";
import i18n from "@/libs/i18n";
import {translatePlanningNotificationStatus} from "@/utils/planningNotificationLabels";
import ValidateViewModal from "@/views/user_views/ValidateViewModal.vue";
import ViewsModal from '@/views/components/GridView/widgets/ViewsWidget/ViewsModal.vue';
import UserViewValidatedModal from "@/views/user_views/UserViewValidatedModal.vue";
import ValidateVideoTourModal from '@/views/components/GridView/widgets/VideoTourWidget/ValidateVideoTourModal.vue';
import VideoTourModal from "@/views/components/GridView/widgets/VideoTourWidget/VideoTourModal.vue";
import VideoTourValidatedModal from "@/views/components/GridView/widgets/VideoTourWidget/VideoTourValidatedModal.vue";
import { useVideoTour } from "@/composables/videoTour";

// Task created by the `notify-panel-failure` action plan command. It is not opened in a
// modal: the user drags the notification into a grid slot to review the alarm and comment it.
const PANEL_FAILURE_TASK_TYPE = 'panel-failure';

export default {
  components: {
    BModal,
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
    vSelect,
    ViewAssignedTaskModal,
    ValidateViewModal,
    ViewsModal,
    ValidateVideoTourModal,
    VideoTourModal,
    UserViewValidatedModal,
    VideoTourValidatedModal
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  setup() {
     const { getVideoTours } = useVideoTour();

    const videoTourModalForm = ref(null);
    const user = computed(() => store.getters["user/getUser"]);
    const vm = getCurrentInstance().proxy;

    const can = (...args) => {
      try {
        return typeof vm.$can === 'function' ? vm.$can(...args) : ability.can(...args);
      } catch (e) {
        return ability.can(...args);
      }
    };

    //METHODS
    let userChannel = null;
    let connectSocketTimeout = null;

    const connectSocket = () => {
      userChannel = window.Echo.private(`user-${user.value.id}`);

      userChannel
        .listen('.action-plan', async () => await getActionPlansUser());

      userChannel
        .listen('.action-plan-completed', async () => await getActionPlansCompleted());

      userChannel
        .listen('.view-commented-check', async () => await getUserViewsWithComments());

      userChannel
        .listen('.user-view-validate', () => getUserViewsForValidate());

      userChannel
        .listen('.video-tour-commented-check', async () => getVideoToursWithComments());

      userChannel
        .listen('.video-tour-validate', async () => getVideoToursForValidate());

      userChannel
        .listen('.user-view-was-validated', async (event) => refreshUserViews(event));

      userChannel
        .listen('.video-tour-was-validated', (event) => refreshVideoTours(event));

      userChannel
        .listen('.penetration-testing-validate', async () => await getPenetrationTestingForValidate());

      userChannel
        .listen('.penetration-testing-reopen', async () => await getPenetrationTestingReopened());

      userChannel
        .listen('.security-box-testing-validate', async () => await getSecurityBoxTestingForValidate());

      userChannel
        .listen('.security-box-testing-reopen', async () => await getSecurityBoxTestingReopened());

      userChannel
        .listen('.training-validate', async () => await getTrainingsForValidate());

      userChannel
        .listen('.training-reopen', async () => await getTrainingsReopened());

      userChannel
        .listen('.operational-security-crisis-validate', async () => await getCrisisForValidate());

      userChannel
        .listen('.operational-security-crisis-reopen', async () => await getCrisisReopened());

      userChannel
        .listen('.op-security-significant-events-updated', async () => await fetchSignificantEventsPendingComments());

      userChannel
        .listen('.recording-request-validate', async () => await getRecordingRequestForValidate());

      userChannel
        .listen('.recording-request-reopen', async () => await getRecordingRequestReopened());
      
      userChannel
        .listen('.external-personnel-reminder', externalPersonnelReminderEvent);
    }

    const resolveNotificationRequest = (sourceData, requestFactory, rawResponse = false) => {
      if (sourceData === undefined) {
        return requestFactory();
      }

      return Promise.resolve(rawResponse
        ? {data: sourceData}
        : {data: {data: sourceData}});
    };

    const decorateAggregatedItems = (items, sourceName, occurredAtByKey) => {
      if (!Array.isArray(items)) return items;

      return items.map(item => {
        if (!item || typeof item !== 'object') return item;
        const identifier = item.id ?? item.uuid ?? item.reference_number;
        const occurredAt = identifier == null
          ? null
          : occurredAtByKey.get(`${sourceName}:${identifier}`);

        return occurredAt ? {...item, occurred_at: occurredAt} : item;
      });
    };

    const decorateAggregatedSource = (sourceData, sourceName, occurredAtByKey) => {
      if (Array.isArray(sourceData)) {
        return decorateAggregatedItems(sourceData, sourceName, occurredAtByKey);
      }
      if (!sourceData || typeof sourceData !== 'object') return sourceData;

      if (Array.isArray(sourceData.data)) {
        return {
          ...sourceData,
          data: decorateAggregatedItems(sourceData.data, sourceName, occurredAtByKey),
        };
      }

      if (sourceName === 'planning_released_forms') {
        return Object.keys(sourceData).reduce((result, kind) => {
          const section = sourceData[kind];
          result[kind] = section && Array.isArray(section.scheduled)
            ? {
              ...section,
              scheduled: decorateAggregatedItems(
                section.scheduled,
                `${sourceName}.${kind}`,
                occurredAtByKey,
              ),
            }
            : section;
          return result;
        }, {});
      }

      return sourceData;
    };

    const getAggregatedSource = (aggregate, sourceName, occurredAtByKey) => {
      if (!aggregate || !aggregate.sources) return undefined;
      if (aggregate.meta?.errors && Object.prototype.hasOwnProperty.call(aggregate.meta.errors, sourceName)) {
        return undefined;
      }
      if (!Object.prototype.hasOwnProperty.call(aggregate.sources, sourceName)) return undefined;

      return decorateAggregatedSource(
        aggregate.sources[sourceName],
        sourceName,
        occurredAtByKey,
      );
    };

    const getActionPlansCompleted = async (sourceData) => {
      await (sourceData === undefined
        ? store.dispatch('action_plan/actionPlansCompleted', user.value.id)
        : Promise.resolve({data: sourceData}))
        .then(response => {
          const {data} = response;

          if (data.length) {
            data.forEach(actionPlanInfo => {
              const actionPlanData = {
                action_plan: actionPlanInfo.action_plan,
                id_action_plan: actionPlanInfo.id_action_plan,
                id_user: actionPlanInfo.id_user_assigned_by,
                uuid_action_plan_log: actionPlanInfo.uuid,
                user: actionPlanInfo.user_assigned_by,
                validated: true,
                description: `O usuário ${actionPlanInfo.user.full_name} finalizou a avaliação do ${actionPlanInfo.action_plan.name}`,
                completed: true,
                alarm: actionPlanInfo.alarm,
                occurred_at: actionPlanInfo.occurred_at || actionPlanInfo.updated_at || actionPlanInfo.created_at || null,
              }

              notifications.value.push(actionPlanData);
            });
          }

        })
        .catch(() => {
          // notifications.value = notifications.value;
        })
    }

    const getActionPlansUser = async (sourceData) => {
      await (sourceData === undefined
        ? store.dispatch('action_plan/actionPlansUser')
        : Promise.resolve({data: sourceData}))
        .then(response => {
          const {data} = response;

          // Mantener las notificaciones
          const nonActionPlanNotifications = notifications.value.filter(n =>
            n.type === 'risk' ||
            n.type === 'simulacrum' ||
            n.type === 'bau_complement' ||
            n.type === 'policy_exception' ||
            n.type === 'unit_task' ||
            n.type === 'planning' ||
            n.type === 'operational_procedure' ||
            n.type === 'security_self_audit' ||
            n.type === 'operational_security_form_validation' ||
            n.type === 'planning_released_form' ||
            n.completed === true
          );

          const actionPlanNotifications = data.map(dataActionPlan => {
            let deadline = dataActionPlan.deadline || null;

            if (!deadline && dataActionPlan.uuid_action_plan_log && dataActionPlan.action_plan && dataActionPlan.action_plan.action_plan_logs) {
              const matchingLog = dataActionPlan.action_plan.action_plan_logs.find(
                log => log.uuid === dataActionPlan.uuid_action_plan_log
              );
              if (matchingLog) {
                deadline = matchingLog.deadline || matchingLog.dead_line || null;
              }
            }

            if (!deadline && dataActionPlan.action_plan) {
              deadline = dataActionPlan.action_plan.deadline || null;
            }

            return {
              ...dataActionPlan,
              validated: false,
              completed: false,
              deadline: deadline
            };
          });

          notifications.value = [...nonActionPlanNotifications, ...actionPlanNotifications];
        })
        .catch(() => {
          notifications.value = notifications.value.filter(n =>
            n.type === 'risk' ||
            n.type === 'simulacrum' ||
            n.type === 'bau_complement' ||
            n.type === 'policy_exception' ||
            n.type === 'unit_task' ||
            n.type === 'planning' ||
            n.type === 'operational_procedure' ||
            n.type === 'security_self_audit' ||
            n.type === 'operational_security_form_validation' ||
            n.type === 'planning_released_form' ||
            n.completed === true
          );
        })
    }

    // Handler para el evento update-log
    const handleUpdateLog = async () => {
      await getActionPlansUser();
    }

    const loadInitialNotifications = async () => {
      let aggregate = null;

      try {
        const {data} = await axios.get('/v1/user-notifications', {
          params: {limit: 500},
        });
        aggregate = data?.data;

        if (!aggregate?.sources) {
          throw new Error('Invalid user notifications response');
        }
      } catch (error) {
        console.error('Error fetching aggregated user notifications:', error);
      }

      if (aggregate?.meta?.partial) {
        console.warn('Some aggregated notification sources failed:', aggregate.meta.errors);
      }

      const loaders = [
        [getActionPlansUser, 'action_plans_assigned'],
        [getActionPlansCompleted, 'action_plans_completed'],
        [fetchUserRiskEvaluations, 'risk_evaluations'],
        [fetchUserSimulacrums, 'simulacrums'],
        [fetchUserBauComplements, 'bau_complements'],
        [fetchUserPolicyExceptions, 'policy_exceptions'],
        [fetchUserAssignedPlanning, 'planning_assigned'],
        [fetchUserReleasedPlanningForms, 'planning_released_forms'],
        [fetchOperationalProcedureSimulacrums, 'operational_procedures'],
        [fetchUserSecuritySelfAudit, 'security_self_audits'],
        [fetchOperationalSecurityFormValidations, 'operational_security_form_validations'],
        [fetchUserAssignedUnitTasks, 'unit_tasks'],
        [getUserViewsForValidate, 'user_views_for_validation'],
        [getUserViewsWithComments, 'user_views_with_comments'],
        [getVideoToursForValidate, 'video_tours_for_validation'],
        [getVideoToursWithComments, 'video_tours_with_comments'],
        [getPenetrationTestingForValidate, 'penetration_testing_for_validation'],
        [getPenetrationTestingReopened, 'penetration_testing_reopened'],
        [getSecurityBoxTestingForValidate, 'security_box_testing_for_validation'],
        [getSecurityBoxTestingReopened, 'security_box_testing_reopened'],
        [getTrainingsForValidate, 'trainings_for_validation'],
        [getTrainingsReopened, 'trainings_reopened'],
        [getCrisisForValidate, 'crises_for_validation'],
        [getCrisisReopened, 'crises_reopened'],
        [fetchSignificantEventsPendingComments, 'significant_events_pending_comments'],
        [getRecordingRequestForValidate, 'recording_requests_for_validation'],
        [getRecordingRequestReopened, 'recording_requests_reopened'],
      ];
      const occurredAtByKey = new Map(
        (aggregate?.notifications || []).map(notification => [notification.key, notification.occurred_at]),
      );

      for (const [loader, sourceName] of loaders) {
        await loader(getAggregatedSource(aggregate, sourceName, occurredAtByKey));
      }
    };

    //HOOKS
    onMounted(async () => {
      await loadInitialNotifications();

      connectSocketTimeout = setTimeout(connectSocket, 2000);
      EventBus.on('action-plan', onLocalActionPlanNotification);
      EventBus.on('update-log', handleUpdateLog);
      EventBus.on('testing-validated-or-rejected', (id, type) => removeTestingNotification(id, type));
      EventBus.on('training-validated-or-rejected', (data) => removeTrainingNotification(data));
      EventBus.on('crisis-validated-or-rejected', (data) => removeNotificationByType(data));
      EventBus.on('recording-request-validated-or-rejected', (data) => removeNotificationByType(data));
    });

    onUnmounted(() => {
      clearTimeout(connectSocketTimeout);
      if (userChannel) {
        [
          '.action-plan',
          '.action-plan-completed',
          '.view-commented-check',
          '.user-view-validate',
          '.video-tour-commented-check',
          '.video-tour-validate',
          '.user-view-was-validated',
          '.video-tour-was-validated',
          '.penetration-testing-validate',
          '.penetration-testing-reopen',
          '.security-box-testing-validate',
          '.security-box-testing-reopen',
          '.training-validate',
          '.training-reopen',
          '.operational-security-crisis-validate',
          '.operational-security-crisis-reopen',
          '.op-security-significant-events-updated',
          '.recording-request-validate',
          '.recording-request-reopen',
        ].forEach(event => userChannel.stopListening(event));
      }
      EventBus.off('action-plan', onLocalActionPlanNotification);
      EventBus.off('update-log', handleUpdateLog);
      EventBus.off('testing-validated-or-rejected', (data) => removeTestingNotification(data));
      EventBus.off('training-validated-or-rejected', (data) => removeTrainingNotification(data));
      EventBus.on('recording-request-validated-or-rejected', (data) => removeNotificationByType(data));
    });

    //COMPOSABLES
    const {t} = useI18nUtils();

    const toast = useToast();

    const {onActionPlanSelected} = useActionPlan({});

    //DATA
    const loading = ref(false);

    const currentPreviewSelected = ref(null);
    const notifications = ref([]);
    const selectedTask = ref(null);
    const isDragging = ref(false);
    const suppressClickUntil = ref(0);
    const showModalUserViews = ref(false);
    const showViewModal = ref(false);
    const showUserViewValidatedModal = ref(false);
    const userViewSelected = ref({
      id: null,
      userViewValidation: null,
      comments: null
    });
    const userViewData = ref({});
    const userVideoTourData = ref({});
    const showModalVideoTour = ref(false);
    const videTourSelected = ref({});
    const showVideoTourValidatedModal = ref(false);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    // Shared helpers for reviewer gating (use latest status by highest id)
    const getLatestStatus = (ev) => {
      const arr = Array.isArray(ev?.statuses) ? ev.statuses : [];
      if (arr.length) {
        return arr.reduce((max, s) => (Number(s?.id) > Number(max?.id || -Infinity) ? s : max), null);
      }
      return ev?.last_status || ev?.status || null;
    };

    const getAssignedReviewerId = (ev) => {
      const st = getLatestStatus(ev);
      const a = st?.id_user || st?.user?.id || null;
      const n = Number(a);
      return Number.isFinite(n) ? n : null;
    };

    const isInReview = (ev) => {
      const st = getLatestStatus(ev);
      const name = String(st?.name || '').toLowerCase();
      if (name) return name === 'in_review';
      const code = Number(st?.id_status);
      return code === 3;
    };


    // Helpers to format state like the live notifications
    const humanize = (str = '') => String(str).replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
    const labelForState = (name) => {
      const raw = String(name || '')
      const norm = raw.trim().toLowerCase().replace(/[-\s]+/g, '_')
      const aliases = {canceled: 'cancelled'}
      const canonical = aliases[norm] || norm
      const tryKeys = [`procedure_states.${canonical}`, `procedure_states.value.${canonical}`]
      for (const k of tryKeys) {
        const v = vm.$t ? vm.$t(k) : k
        if (typeof v === 'string' && v !== k) return v
      }
      return humanize(canonical)
    }

    // Deadline helpers
    const calculateDaysDifference = (deadline) => {
      if (!deadline) return null;
      const today = moment().startOf('day');
      const deadlineDate = moment(deadline).startOf('day');
      return deadlineDate.diff(today, 'days');
    }

    const getDeadlineTooltip = (deadline) => {
      if (!deadline) return '';
      const daysDiff = calculateDaysDifference(deadline);

      const translateWithParams = (key, params) => {
        try {
          return i18n.t(key, params);
        } catch (e) {
          let text = t(key);
          if (params && typeof text === 'string') {
            Object.keys(params).forEach(paramKey => {
              text = text.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), params[paramKey]);
            });
          }
          return text;
        }
      };

      if (daysDiff < 0) {
        return translateWithParams('action_plan.deadlineOverdue', { days: Math.abs(daysDiff) });
      } else if (daysDiff === 0) {
        return translateWithParams('action_plan.deadlineToday');
      } else {
        return translateWithParams('action_plan.deadlineRemaining', { days: daysDiff });
      }
    }

    const formatDeadlineDate = (date) => {
      if (!date) return '-';
      return moment(date).format('YYYY-MM-DD');
    }

    const getDeadlineText = (deadline) => {
      if (!deadline) return '';
      const daysDiff = calculateDaysDifference(deadline);
      if (daysDiff === null) return '';

      // Usar i18n directamente para obtener traducciones con parámetros
      const translateWithParams = (key, params) => {
        try {
          return i18n.t(key, params);
        } catch (e) {
          let text = t(key);
          if (params && typeof text === 'string') {
            Object.keys(params).forEach(paramKey => {
              text = text.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), params[paramKey]);
            });
          }
          return text;
        }
      };

      if (daysDiff < 0) {
        return translateWithParams('action_plan.deadlineOverdue', { days: Math.abs(daysDiff) });
      } else if (daysDiff === 0) {
        return translateWithParams('action_plan.deadlineToday');
      } else {
        return translateWithParams('action_plan.deadlineRemaining', { days: daysDiff });
      }
    }

    const getDeadlineIconClass = (deadline) => {
      if (!deadline) return 'text-warning';
      const daysDiff = calculateDaysDifference(deadline);
      if (daysDiff === null) return 'text-warning';

      // Si está atrasada (cualquier cantidad de días), usar rojo (text-danger)
      // Si está por vencer o el día de vencimiento, usar amarillo (text-warning)
      if (daysDiff < 0) {
        return 'text-danger';
      }
      return 'text-warning';
    }

    const getNotificationDeadline = (notification) => {
      if (notification.deadline) {
        return notification.deadline;
      }

      if (notification.uuid_action_plan_log && notification.action_plan && notification.action_plan.action_plan_logs) {
        const matchingLog = notification.action_plan.action_plan_logs.find(
          log => log.uuid === notification.uuid_action_plan_log
        );
        if (matchingLog) {
          return matchingLog.deadline || matchingLog.dead_line || null;
        }
      }

      if (notification.action_plan && notification.action_plan.deadline) {
        return notification.action_plan.deadline;
      }

      return null;
    }

    const getActionPlanName = (notification) => {
      return (notification.action_plan && notification.action_plan.name) || '';
    }

    const getStatusCreatedDate = (ev) => {
      if (!ev) return '';
      if (ev.last_status && ev.last_status.created_at) {
        return moment(ev.last_status.created_at).format('YYYY-MM-DD HH:mm:ss');
      }
      return '';
    }

    const getNotificationSortTimestamp = (notification) => {
      const dateValue = notification.occurred_at
        || notification.statusDate
        || notification.last_status?.reopened_at
        || notification.last_status?.created_at
        || notification.crisis?.last_status?.reopened_at
        || notification.training?.last_status?.reopened_at
        || notification.penetration_testing?.last_status?.reopened_at
        || notification.security_box_testing?.last_status?.reopened_at
        || notification.request?.created
        || notification.training?.registration_date
        || notification.penetration_testing?.registration_date
        || notification.security_box_testing?.registration_date
        || notification.created_at
        || notification.updated_at
        || (notification.action_plan && notification.action_plan.created_at);
      if (!dateValue) return 0;
      const parsed = moment(dateValue);
      return parsed.isValid() ? parsed.valueOf() : 0;
    };

    const normalizeAssignedUnitTaskData = (task = {}) => {
      return {
        ...task,
        id_form_answer: task?.id_form_answer ?? task?.form_answer_id ?? task?.form?.id ?? null,
        id_form: task?.id_form ?? null,
        id_alarm: task?.id_alarm ?? task?.alarm_id ?? task?.alarm?.id ?? null,
        alarm: task?.alarm ?? null,
      };
    };

    const panelFailureLabel = () => (vm.$t ? vm.$t('unit.panel_failure_task') : 'Panel failure');

    const getPanelFailureExtras = (normalizedTask, alarm) => {
      const resolvedAlarm = alarm ?? normalizedTask?.alarm;
      const unit = normalizedTask?.unit ?? resolvedAlarm?.unit;
      const alarmType = resolvedAlarm?.alarm_type;
      const rems = unit?.rems;
      const sirh = unit?.sirh;
      const zoneNumber = resolvedAlarm?.zone ?? resolvedAlarm?.zone_number ?? resolvedAlarm?.device_id ?? null;
      const zoneLabel = vm.$t ? vm.$t('unit.zone_number') : 'Zona';
      const sectorName = unit?.sector?.name ?? null;
      const regionLabel = vm.$t ? vm.$t('unit.region_label') : 'Región';

      const extras = [];
      if (alarmType) extras.push(alarmType);
      if (zoneNumber != null && zoneNumber !== '') extras.push(`${zoneLabel}: ${zoneNumber}`);
      if (sectorName) extras.push(`${regionLabel}: ${sectorName}`);
      if (rems) extras.push(`REMS: ${String(rems).toUpperCase()}`);
      if (sirh) extras.push(`SIRH: ${String(sirh).toUpperCase()}`);
      return extras;
    };

    const buildPanelFailureTitle = (normalizedTask, titleValue, alarm) => {
      const base = `${panelFailureLabel()}: ${titleValue}`;
      const extras = getPanelFailureExtras(normalizedTask, alarm);
      return extras.length ? `${base} | ${extras.join(' | ')}` : base;
    };

    const isPanelFailureNotification = (notification) => {
      return notification?.type === 'unit_task'
        && notification?.taskData?.type === PANEL_FAILURE_TASK_TYPE;
    };

    const buildPanelFailureSlotData = (alarm) => ({
      type: SLOT_TYPES.INFO,
      name: `${panelFailureLabel()} ${alarm.id}`,
      data: {
        ...JSON.parse(JSON.stringify(alarm)),
        in_app_source: SOURCES.ALARM_VIEW,
      },
      source: SOURCES.ALARM_VIEW,
    });

    const hydratePanelFailureNotification = async (notification) => {
      if (!isPanelFailureNotification(notification) || notification.taskData.alarm?.id) {
        return notification;
      }

      const alarm = await resolveAlarmFromTask(notification.taskData);
      if (!alarm) {
        return notification;
      }

      notification.taskData = {
        ...notification.taskData,
        alarm,
        id_alarm: notification.taskData.id_alarm ?? alarm.id,
      };

      const titleValue = notification.taskData.id_alarm != null
        ? `Alarma Id ${notification.taskData.id_alarm}`
        : 'Alarma Id';
      notification.action_plan = {
        ...notification.action_plan,
        name: buildPanelFailureTitle(notification.taskData, titleValue, alarm),
      };

      return notification;
    };

    const buildAssignedUnitTaskNotification = (task) => {
      const normalizedTask = normalizeAssignedUnitTaskData(task);
      const isNotificationFormTask = normalizedTask.type === 'notification-form';
      const isAlarmTask = normalizedTask.type === 'alarm';
      const isInAppNotificationTask = normalizedTask.type === 'notification';
      const isPanelFailureTask = normalizedTask.type === PANEL_FAILURE_TASK_TYPE;
      const notificationSubject = String(normalizedTask.subject ?? '').trim();
      const hasNotificationSubject = notificationSubject !== '';
      const isFormTask =
        normalizedTask.type === 'form' ||
        normalizedTask.type === 'answered_form' ||
        normalizedTask.type === 'form-created-with-relation' ||
        isNotificationFormTask;
      const isSecurityFormTask = normalizedTask.type === 'answered_form' || isNotificationFormTask;
      const titleKey = isSecurityFormTask
        ? 'unit.assigned_security_form_task'
        : (isFormTask ? 'unit.assigned_form_task' : 'unit.assigned_task');
      const titleLabel = vm.$t ? vm.$t(titleKey) : (isSecurityFormTask ? 'Assigned security form task' : (isFormTask ? 'Assigned form task' : 'Assigned task'));
      const formLabelFallback = vm.$t ? vm.$t('unit.form_label_fallback') : 'Form';
      const alarmIdentifierLabel = normalizedTask.id_alarm != null
        ? `Alarma Id ${normalizedTask.id_alarm}`
        : 'Alarma Id';
      const titleValue = isFormTask
        ? (normalizedTask.form_answer_bind?.name || normalizedTask.form?.name || formLabelFallback)
        : ((isAlarmTask || isPanelFailureTask) ? alarmIdentifierLabel : (normalizedTask.unit?.description || 'N/A'));
      const actionPlanName = isPanelFailureTask
        ? buildPanelFailureTitle(normalizedTask, titleValue)
        : (isAlarmTask
        ? (hasNotificationSubject ? notificationSubject : `Notificación: ${titleValue}`)
        : (isInAppNotificationTask
        ? (hasNotificationSubject
          ? notificationSubject
          : `Notificación: ${normalizedTask.comment || ''}`)
        : (isNotificationFormTask
        ? `Notificación: ${titleValue}`
        : `${titleLabel}: ${titleValue}`)));
      const subtitle = isFormTask ? '' : (normalizedTask.unit?.router?.tenant?.name || normalizedTask.unit?.region?.name || '');
      const statusDate = normalizedTask.created_at ? moment(normalizedTask.created_at).format('YYYY-MM-DD HH:mm:ss') : '';

      return {
        id: `unit-task-${normalizedTask.id}`,
        taskId: normalizedTask.id,
        type: 'unit_task',
        name: 'UT',
        action_plan: {
          name: actionPlanName
        },
        user: {
          user: subtitle
        },
        status: normalizedTask.status,
        statusDate,
        occurred_at: normalizedTask.occurred_at || normalizedTask.updated_at || normalizedTask.created_at || null,
        taskData: normalizedTask
      };
    };

    const normalizeAlarmRequestPath = (requestPath) => {
      if (!requestPath || typeof requestPath !== 'string') {
        return null;
      }
      if (!/^https?:\/\//i.test(requestPath)) {
        return requestPath;
      }
      try {
        const parsed = new URL(requestPath, window.location.origin);
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
      } catch (_) {
        return null;
      }
    };

    const isAlarmPayloadComplete = (alarmData) => {
      if (!alarmData || typeof alarmData !== 'object') {
        return false;
      }
      const hasUnitDescription = Boolean(alarmData?.unit?.description);
      const hasRefreshLink = Boolean(alarmData?.refresh_link);
      return hasUnitDescription && hasRefreshLink;
    };

    const fetchAlarmFromRefreshLink = async (refreshLink) => {
      const normalizedPath = normalizeAlarmRequestPath(refreshLink);
      if (!normalizedPath) {
        return null;
      }
      try {
        const response = await axios.get(normalizedPath);
        return response?.data || null;
      } catch (_) {
        return null;
      }
    };

    const fetchAlarmByIdWithRelations = async (alarmId) => {
      if (alarmId == null) {
        return null;
      }
      try {
        const response = await axios.get('/v1/services/alarms/alarm-by-id', {
          params: { alarm_id: alarmId },
        });
        const payload = response?.data ?? null;
        const alarm = payload?.data ?? payload;
        return alarm && alarm.id ? alarm : null;
      } catch (_) {
        return null;
      }
    };

    const resolveAlarmFromTask = async (taskData) => {
      const normalizedTask = normalizeAssignedUnitTaskData(taskData);
      const alarmId = normalizedTask.id_alarm;
      let resolvedAlarm = normalizedTask.alarm && normalizedTask.alarm.id
        ? normalizedTask.alarm
        : null;

      if (!resolvedAlarm && alarmId == null) {
        return null;
      }

      if (!resolvedAlarm && alarmId != null) {
        resolvedAlarm = await fetchAlarmByIdWithRelations(alarmId);
      }

      if (!resolvedAlarm) {
        return null;
      }

      if (isAlarmPayloadComplete(resolvedAlarm)) {
        return resolvedAlarm;
      }

      const hydratedAlarmFromRefresh = await fetchAlarmFromRefreshLink(resolvedAlarm.refresh_link);
      if (hydratedAlarmFromRefresh) {
        return hydratedAlarmFromRefresh;
      }

      if (alarmId != null) {
        const hydratedAlarmFromRelations = await fetchAlarmByIdWithRelations(alarmId);
        if (hydratedAlarmFromRelations) {
          return hydratedAlarmFromRelations;
        }
      }

      return resolvedAlarm;
    };

    const filteredNotifications = computed(() => {
      const list = notifications.value.filter(notification => {
        const notificationTypes = [
          'user_view_validate',
          'user_view_commented',
          'user_view_was_validated',
          'video_tour_validate',
          'video_tour_commented',
          'video_tour_was_validated',
          'penetration_testing_validate',
          'security_box_testing_validate',
          'penetration_testing_reopened',
          'security_box_testing_reopened',
          'training_validate',
          'training_reopened',
          'crisis_validate',
          'crisis_reopened',
          'recording_request_validate',
          'recording_request_reopened',
          'external_personnel_reminder'
        ];

        return (notification.action_plan && notification.action_plan.name) || notificationTypes.includes(notification.type);

        //return (notification.action_plan && notification.action_plan.name) || (notification.type === 'user_view_validate' || notification.type === 'user_view_commented' || notification.type === 'user_view_was_validated' || notification.type === 'video_tour_validate' || notification.type === 'video_tour_commented' || notification.type === 'video_tour_was_validated' || notification.type === 'penetration_testing_validate' || notification.type === 'security_box_testing_validate' || notification.type === 'penetration_testing_reopened' || notification.type === 'security_box_testing_reopened' || notification.type === 'training_validate' || notification.type === 'training_reopened' || notification.type === 'crisis_validate' || notification.type === 'crisis_reopened');
      });
      return [...list].sort((a, b) => getNotificationSortTimestamp(b) - getNotificationSortTimestamp(a));
    });

    const fetchUserAssignedUnitTasks = async (sourceData) => {
      try {
        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/device_assignment_task_user_units'),
          true,
        );

        const list = Array.isArray(data) ? data : [];

        const pendingTasks = list.filter(task => task.status === 'pending');

        const taskNotifications = pendingTasks.map(task => buildAssignedUnitTaskNotification(task));

        if (sourceData === undefined) {
          await Promise.all(taskNotifications.map(hydratePanelFailureNotification));
        }

        // Merge/dedupe by id for task notifications
        const nonTask = notifications.value.filter(n => n.type !== 'unit_task');
        const dedupedTaskMap = new Map();
        notifications.value
          .filter(n => n.type === 'unit_task')
          .forEach(t => dedupedTaskMap.set(t.id, t));
        taskNotifications.forEach(t => dedupedTaskMap.set(t.id, t));

        notifications.value = [...nonTask, ...Array.from(dedupedTaskMap.values())];
      } catch (error) {
        console.error('Error fetching assigned unit tasks:', error);
      }
    }

    const fetchUserRiskEvaluations = async (sourceData) => {
      try {
        const idUser = user.value && user.value.id ? user.value.id : null;
        if (!idUser) return;

        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/risk_evaluations', {
            params: {users: idUser, status: ['in_progress', 'in_review', 'reassigned']},
          }),
        );

        const list = Array.isArray(data?.data) ? data.data : [];

        const listFiltered = list.filter(ev => {
          if (isInReview(ev)) {
            const assignedId = getAssignedReviewerId(ev);
            return Number(assignedId) === Number(user.value.id);
          }
          return true;
        });

        const riskNotifications = listFiltered.map(ev => {
          const statusDate = getStatusCreatedDate(ev);
          const title = vm.$tc ? vm.$tc('risk.evaluation.title', 1) : 'Evaluación De Riesgo';
          const reference = ev.reference_number || '';
          const state = labelForState(ev?.last_status?.name);
          let name = `${title} ${reference} : ${state}`;
          return {
            id: ev.id,
            type: 'risk',
            name: 'RE',
            action_plan: {
              name: name.trim()
            },
            statusDate: statusDate,
            occurred_at: ev.occurred_at || null,
            user: {user: ev?.unit?.description || ''},
            status: (ev?.last_status?.name || '').toLowerCase(),
          };
        });

        // Merge/dedupe by id for risk notifications
        const nonRisk = notifications.value.filter(n => n.type !== 'risk');
        const dedupedRiskMap = new Map();
        riskNotifications.forEach(r => dedupedRiskMap.set(r.id, r));
        notifications.value
          .filter(n => n.type === 'risk')
          .forEach(r => {
            if (!dedupedRiskMap.has(r.id)) dedupedRiskMap.set(r.id, r);
          });

        const mergedRisk = Array.from(dedupedRiskMap.values());
        // Put risk notifications first
        notifications.value = [...mergedRisk, ...nonRisk];
      } catch (_) {
        // silent
      }
    }

    const fetchUserSimulacrums = async (sourceData) => {
      try {
        const idUser = user.value && user.value.id ? user.value.id : null;
        if (!idUser) return;

        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/simulacrums', {
            params: {users: idUser, status: ['in_progress', 'in_review', 'reassigned']},
          }),
        );

        const list = Array.isArray(data?.data) ? data.data : [];

        const listFiltered = list.filter(ev => {
          if (isInReview(ev)) {
            const assignedId = getAssignedReviewerId(ev);
            return Number(assignedId) === Number(user.value.id);
          }
          return true;
        });

        const simNotifications = listFiltered.map(ev => {
          const statusDate = getStatusCreatedDate(ev);
          const title = vm.$tc ? vm.$tc('simulacrum.title', 1) : 'Simulacro';
          const reference = ev.reference_number || '';
          const state = labelForState(ev?.last_status?.name);
          let name = `${title} ${reference} : ${state}`;
          return {
            id: ev.id,
            type: 'simulacrum',
            name: 'SI',
            action_plan: {
              name: name.trim()
            },
            statusDate: statusDate,
            occurred_at: ev.occurred_at || null,
            user: {user: ev?.unit?.description || ''},
            status: (ev?.last_status?.name || '').toLowerCase(),
            route: `/risk/simulacrums?id=${ev.id}`,
          };
        });

        const nonSim = notifications.value.filter(n => n.type !== 'simulacrum');
        const dedupedSimMap = new Map();
        simNotifications.forEach(s => dedupedSimMap.set(s.id, s));
        notifications.value
          .filter(n => n.type === 'simulacrum')
          .forEach(s => {
            if (!dedupedSimMap.has(s.id)) dedupedSimMap.set(s.id, s);
          });

        const mergedSim = Array.from(dedupedSimMap.values());

        const risks = notifications.value.filter(n => n.type === 'risk');
        const others = notifications.value.filter(n => n.type !== 'risk' && n.type !== 'simulacrum');
        notifications.value = [...risks, ...mergedSim, ...others];
      } catch (_) {
      }

    }

    const fetchUserBauComplements = async (sourceData) => {
      try {
        const idUser = user.value && user.value.id ? user.value.id : null;
        if (!idUser) return;

        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/bau-complements', {
            params: {users: idUser, status: ['in_progress', 'in_review', 'reassigned']},
          }),
        );

        const list = Array.isArray(data?.data) ? data.data : [];

        const listFiltered = list.filter(ev => {
          if (isInReview(ev)) {
            const assignedId = getAssignedReviewerId(ev);
            return Number(assignedId) === Number(user.value.id);
          }
          return true;
        });

        const bauNotifications = listFiltered.map(ev => {
          const statusDate = getStatusCreatedDate(ev);
          const title = vm.$tc ? vm.$tc('bau_complement.title', 1) : 'Complemento BAU';
          const reference = ev.reference_number || '';
          const state = labelForState(ev?.last_status?.name);
          const name = `${title} ${reference} : ${state}`;
          return {
            id: ev.id,
            type: 'bau_complement',
            name: 'BAU',
            action_plan: {
              name: name.trim()
            },
            statusDate: statusDate,
            occurred_at: ev.occurred_at || null,
            user: {user: ev?.unit?.description || ''},
            status: (ev?.last_status?.name || '').toLowerCase(),
            route: `/risk/bau-complements?id=${ev.id}`,
          };
        });

        const dedupedBauMap = new Map();
        bauNotifications.forEach(b => dedupedBauMap.set(b.id, b));
        notifications.value
          .filter(n => n.type === 'bau_complement')
          .forEach(b => {
            if (!dedupedBauMap.has(b.id)) dedupedBauMap.set(b.id, b);
          });

        const mergedBau = Array.from(dedupedBauMap.values());

        const risks = notifications.value.filter(n => n.type === 'risk');
        const sims = notifications.value.filter(n => n.type === 'simulacrum');
        const others = notifications.value.filter(
          n => n.type !== 'risk' && n.type !== 'simulacrum' && n.type !== 'bau_complement'
        );
        notifications.value = [...risks, ...sims, ...mergedBau, ...others];
      } catch (_) {
      }

    }

    const fetchUserPolicyExceptions = async (sourceData) => {
      try {
        const idUser = user.value && user.value.id ? user.value.id : null;
        if (!idUser) return;

        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/policy-exceptions', {
            params: {
              notification: true,
              users: idUser,
              status: ['in_progress', 'in_review', 'reassigned'],
            },
          }),
        );

        const rawList = data?.data?.data ?? data?.data ?? [];
        const list = Array.isArray(rawList) ? rawList : [];

        const peNotifications = list.map(ev => {
          const statusDate = ev.updated_at || ev.created_at
            ? moment(ev.updated_at || ev.created_at).format('YYYY-MM-DD HH:mm:ss')
            : '';
          const title = vm.$tc ? vm.$tc('policy_exception.title', 1) : 'Excepción de políticas';
          const reference = ev.reference_number || '';
          const state = labelForState(ev.status);
          const name = `${title} ${reference} : ${state}`;
          return {
            id: ev.id,
            type: 'policy_exception',
            name: 'EP',
            action_plan: { name: name.trim() },
            statusDate,
            occurred_at: ev.occurred_at || null,
            user: { user: ev.unit_name || '' },
            status: String(ev.status || '').toLowerCase(),
            route: `/policy-exceptions/${ev.id}`,
          };
        });

        const nonPe = notifications.value.filter(n => n.type !== 'policy_exception');
        const dedupedPeMap = new Map();
        peNotifications.forEach(p => dedupedPeMap.set(p.id, p));
        notifications.value
          .filter(n => n.type === 'policy_exception')
          .forEach(p => {
            if (!dedupedPeMap.has(p.id)) dedupedPeMap.set(p.id, p);
          });

        const mergedPe = Array.from(dedupedPeMap.values());
        const risks = notifications.value.filter(n => n.type === 'risk');
        const sims = notifications.value.filter(n => n.type === 'simulacrum');
        const others = notifications.value.filter(n => n.type !== 'risk' && n.type !== 'simulacrum' && n.type !== 'policy_exception');
        notifications.value = [...risks, ...sims, ...mergedPe, ...others];
      } catch (_) {
      }
    }

    const fetchUserAssignedPlanning = async (sourceData) => {
      try {
        const idUser = user.value && user.value.id ? user.value.id : null;
        if (!idUser) return;
        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/planning', {
            params: {
              getPlansAssigned: true,
              id_user: idUser,
            },
          }),
        );
        const rawList = data?.data?.data ?? data?.data ?? [];
        const list = Array.isArray(rawList) ? rawList : [];
        const planningNotifications = list.map(item => {
          const statusSource = item.status?.code || item.status?.name || item.status || '';
          const title = i18n.t('planning.toast_planning_title');
          const idLine = i18n.t('planning.toast_planning_id_line', {id: item.id});
          const statusLabel = translatePlanningNotificationStatus(i18n.t.bind(i18n), statusSource);
          const statusDate = item.updated_at || item.created_at
            ? moment(item.updated_at || item.created_at).format('YYYY-MM-DD HH:mm:ss')
            : '';
          return {
            id: item.id,
            type: 'planning',
            name: 'PL',
            action_plan: {name: `${title} — ${idLine} — ${statusLabel}`},
            statusDate,
            occurred_at: item.occurred_at || null,
            user: {user: item.units || item.unit_name || ''},
            status: String(statusSource || '').toLowerCase(),
            route: `/planning/${item.id}`,
          };
        });
        const nonPlanning = notifications.value.filter(n => n.type !== 'planning');
        const dedupedPlanningMap = new Map();
        planningNotifications.forEach(p => dedupedPlanningMap.set(p.id, p));
        notifications.value
          .filter(n => n.type === 'planning')
          .forEach(p => {
            if (!dedupedPlanningMap.has(p.id)) dedupedPlanningMap.set(p.id, p);
          });
        notifications.value = [...Array.from(dedupedPlanningMap.values()), ...nonPlanning];
      } catch (_) {
      }
    }

    const fetchUserReleasedPlanningForms = async (sourceData) => {
      try {
        const idUser = user.value && user.value.id ? user.value.id : null;
        if (!idUser) return;
        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/planning/user-released-forms', {
            params: {id_user: idUser},
          }),
        );
        const payload = data?.data?.data ?? data?.data ?? {};
        const kinds = ['simulacrum', 'operational_procedure', 'security_self_audit', 'risk_evaluation'];
        const titleBase = vm.$t ? vm.$t('planning.scheduled_programming_notification') : 'Planificación programada';
        const next = [];
        for (const kind of kinds) {
          const section = payload[kind];
          const rows = Array.isArray(section?.scheduled) ? section.scheduled : [];
          for (const row of rows) {
            if (!row || row.id == null) continue;
            const scheduledStatusAt = row.scheduled_status_at ? moment(row.scheduled_status_at) : null;
            if (!scheduledStatusAt || !scheduledStatusAt.isValid()) continue;
            if (!scheduledStatusAt.isSame(moment(), 'month')) continue;
            const reference = row.reference_number || `ID ${row.id}`;
            const statusDate = row.updated_at || row.created_at
              ? moment(row.updated_at || row.created_at).format('YYYY-MM-DD HH:mm:ss')
              : '';
            const unitLabel = row.unit?.description || row.unit?.name || '';
            next.push({
              id: `planning-released-${kind}-${row.id}`,
              type: 'planning_released_form',
              entityKind: kind,
              planningRecord: row,
              action_plan: { name: `${titleBase} — ${reference}` },
              statusDate,
              occurred_at: row.occurred_at || null,
              user: { user: unitLabel },
              name: 'PR',
            });
          }
        }
        const nonReleased = notifications.value.filter(n => n.type !== 'planning_released_form');
        const dedupedReleasedMap = new Map();
        next.forEach(n => dedupedReleasedMap.set(n.id, n));
        notifications.value
          .filter(n => n.type === 'planning_released_form')
          .forEach(n => {
            if (!dedupedReleasedMap.has(n.id)) dedupedReleasedMap.set(n.id, n);
          });
        notifications.value = [...Array.from(dedupedReleasedMap.values()), ...nonReleased];
      } catch (_) {
      }
    };

    const fetchUserSecuritySelfAudit = async (sourceData) => {
      try {
        const idUser = user.value && user.value.id ? user.value.id : null;
        if (!idUser) return;

        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/security_self_audits', {
            params: {users: idUser, status: ['in_progress', 'in_review', 'reassigned']},
          }),
        );

        const list = Array.isArray(data?.data) ? data.data : [];

        const listFiltered = list.filter(ev => {
          if (isInReview(ev)) {
            const assignedId = getAssignedReviewerId(ev);
            return Number(assignedId) === Number(user.value.id);
          }
          return true;
        });

        const simNotifications = listFiltered.map(ev => {
          const statusDate = getStatusCreatedDate(ev);
          const title = vm.$tc ? vm.$tc('security_self_audit.title', 1) : 'Simulacro';
          const reference = ev.reference_number || '';
          const state = labelForState(ev?.last_status?.name);
          let name = `${title} ${reference} : ${state}`;
          return {
            id: ev.id,
            type: 'security_self_audit',
            name: 'SSA',
            action_plan: {
              name: name.trim()
            },
            statusDate: statusDate,
            occurred_at: ev.occurred_at || null,
            user: {user: ev?.unit?.description || ''},
            status: (ev?.last_status?.name || '').toLowerCase(),
            route: `/risk/security_self_audit/audits?id=${ev.id}`,
          };
        });

        const nonSim = notifications.value.filter(n => n.type !== 'security_self_audit');
        const dedupedSimMap = new Map();
        simNotifications.forEach(s => dedupedSimMap.set(s.id, s));
        notifications.value
          .filter(n => n.type === 'security_self_audit')
          .forEach(s => {
            if (!dedupedSimMap.has(s.id)) dedupedSimMap.set(s.id, s);
          });

        const mergedSim = Array.from(dedupedSimMap.values());

        const risks = notifications.value.filter(n => n.type === 'risk');
        const others = notifications.value.filter(n => n.type !== 'risk' && n.type !== 'security_self_audit');
        notifications.value = [...risks, ...mergedSim, ...others];
      } catch (_) {
      }
    }

    const fetchOperationalProcedureSimulacrums = async (sourceData) => {
      try {
        const idUser = user.value && user.value.id ? user.value.id : null;
        if (!idUser) return;

        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/operational_procedure', {
            params: {users: idUser, status: ['in_progress', 'in_review', 'reassigned']},
          }),
        );

        const list = Array.isArray(data?.data) ? data.data : [];

        const listFiltered = list.filter(ev => {
          if (isInReview(ev)) {
            const assignedId = getAssignedReviewerId(ev);
            return Number(assignedId) === Number(user.value.id);
          }
          return true;
        });

        const opNotifications = listFiltered.map(ev => {
          const statusDate = getStatusCreatedDate(ev);
          const title = vm.$tc ? vm.$tc('operational_procedure_exercise.title', 1) : 'Ejercicio de Procedimiento Operativo';
          const reference = ev.reference_number || '';
          const state = labelForState(ev?.last_status?.name);
          let name = `${title} ${reference}`;
          name += ` : ${state}`;
          return {
            id: ev.id,
            type: 'operational_procedure',
            name: 'OP',
            action_plan: {
              name: name.trim()
            },
            statusDate: statusDate,
            occurred_at: ev.occurred_at || null,
            user: {user: ev?.unit?.description || ''},
            status: (ev?.last_status?.name || '').toLowerCase(),
            route: `/risk/operational_procedure?id=${ev.id}`,
          };
        });

        const nonOp = notifications.value.filter(n => n.type !== 'operational_procedure');
        const dedupedOpMap = new Map();
        opNotifications.forEach(s => dedupedOpMap.set(s.id, s));
        notifications.value
          .filter(n => n.type === 'operational_procedure')
          .forEach(s => {
            if (!dedupedOpMap.has(s.id)) dedupedOpMap.set(s.id, s);
          });

        const mergedOp = Array.from(dedupedOpMap.values());

        const risks = notifications.value.filter(n => n.type === 'risk');
        const sims = notifications.value.filter(n => n.type === 'simulacrum');
        const others = notifications.value.filter(n => n.type !== 'risk' && n.type !== 'simulacrum' && n.type !== 'operational_procedure');
        notifications.value = [...risks, ...sims, ...mergedOp, ...others];
      } catch (_) {
      }
    }

    // Operational Security Forms
    const fetchOperationalSecurityFormValidations = async (sourceData) => {
      try {
        const idUser = user.value && user.value.id ? user.value.id : null;

        if (!idUser) return;

        const params = {id_user: idUser, status: ['pending', 'review', 'reopened', 'rejected']}
        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/operational-security-forms/form-validation', {params}),
        );

        const list = Array.isArray(data?.data) ? data.data : [];

        // const listFiltered = list.filter(ev => {
        //   if(ev.last_status.name === 'in_review' && !vm.$can('review_simulacrum', 'Simulacrum')) {
        //     return false;
        //   }
        //   return true;
        // });

        const opNotifications = list.map(ev => ({
          id: ev.id,
          type: 'operational_security_form_validation',
          name: 'FSO',
          action_plan: {
            name: ev.form?.template.name,
            reference: ev.form?.ref,
            template_answer_id: ev.form?.id,
            formValidationData: ev,
            formValidation: true,
          },
          user: {user: ev.user_validator?.full_name || '-'},
          status: ev.status,
          occurred_at: ev.updated_at || ev.created_at || ev.status_date || null,
        }));

        const currentNotifications = notifications.value.filter(n => n.type !== 'operational_security_form_validation');

        notifications.value = [...opNotifications, ...currentNotifications];

        if (sourceData === undefined) {
          EventBus.emit("operational_security_reload_forms_and_list");
        }

      } catch (error) {
        console.error('Error fetching op security form validations:', error);
      }
    }

    const TYPES_WITH_STATUS_DATE = ['risk', 'simulacrum', 'bau_complement', 'policy_exception', 'operational_procedure', 'security_self_audit'];

    const ensurePayloadStatusDate = (payload) => {
      if (!TYPES_WITH_STATUS_DATE.includes(payload.type)) return payload;
      if (payload.statusDate) return payload;
      return { ...payload, statusDate: moment().format('YYYY-MM-DD HH:mm:ss') };
    };

    const onLocalActionPlanNotification = async (payload) => {
      if (payload.type === 'operational_security_form_validation') {
        fetchOperationalSecurityFormValidations();
      } else if (payload.type === 'planning_released_form') {
        fetchUserReleasedPlanningForms();
      } else if (payload.type === 'unit_task' && payload.taskData) {
        const normalized = buildAssignedUnitTaskNotification({
          ...payload.taskData,
          status: payload.status ?? payload.taskData.status,
          created_at: payload.statusDate || payload.taskData.created_at,
        });
        notifications.value = notifications.value.filter(n => n.id !== normalized.id);
        notifications.value.unshift(normalized);
        await hydratePanelFailureNotification(normalized);
      } else {
        const normalized = ensurePayloadStatusDate(payload);
        notifications.value = notifications.value.filter(n => n.id !== payload.id);
        notifications.value.unshift(normalized);
      }
    }

    const handleTaskUpdated = async (taskId) => {
      if (taskId) {
        notifications.value = notifications.value.filter(n => !(n.type === 'unit_task' && n.taskId === taskId));
      }

      await fetchUserAssignedUnitTasks();
      selectedTask.value = null;
    }

    const openTaskAlarm = async (taskData) => {
      try {
        const resolvedAlarm = await resolveAlarmFromTask(taskData);
        if (!resolvedAlarm) {
          return false;
        }
        await store.dispatch('grid/setAlarmView', { alarm: resolvedAlarm });
        return true;
      } catch (_) {
        return false;
      }
    };

    const openAlarmData = async (data) => {
      if (isPanelFailureNotification(data)) {
        await hydratePanelFailureNotification(data);
        return
      }

      if (data.type === 'unit_task' && data.taskData) {
        const normalizedTaskData = normalizeAssignedUnitTaskData(data.taskData);
        if (normalizedTaskData.type === 'alarm') {
          const resolvedAlarm = await resolveAlarmFromTask(normalizedTaskData);
          selectedTask.value = resolvedAlarm
            ? { ...normalizedTaskData, alarm: resolvedAlarm, id_alarm: normalizedTaskData.id_alarm ?? resolvedAlarm.id }
            : normalizedTaskData;
        } else {
          selectedTask.value = normalizedTaskData;
        }
        vm.$bvModal.show('view-assigned-task-modal');
        return
      }

      const currentPath = (vm.$route && vm.$route.path) ? String(vm.$route.path).replace(/\/+$/, '') : '';

      if (data.type === 'risk' && data.id) {
        const targetPath = '/risk/evaluations';
        if (currentPath === targetPath) {
          vm.$router.push({ path: targetPath, query: { id: data.id } });
        } else {
          const route = vm.$router.resolve({ path: targetPath, query: { id: data.id } });
          window.open(route.href, '_blank');
        }
        return
      }

      if (data.type === 'simulacrum' && data.id) {
        const targetPath = '/risk/simulacrums';
        if (currentPath === targetPath) {
          vm.$router.push({ path: targetPath, query: { id: data.id } });
        } else {
          const route = vm.$router.resolve({ path: targetPath, query: { id: data.id } });
          window.open(route.href, '_blank');
        }
        return
      }

      if (data.type === 'bau_complement' && data.id) {
        const targetPath = '/risk/bau-complements';
        if (currentPath === targetPath) {
          vm.$router.push({ path: targetPath, query: { id: data.id } });
        } else {
          const route = vm.$router.resolve({ path: targetPath, query: { id: data.id } });
          window.open(route.href, '_blank');
        }
        return
      }

      if (data.type === 'operational_procedure' && data.id) {
        const targetPath = '/risk/operational_procedure';
        if (currentPath === targetPath) {
          vm.$router.push({ path: targetPath, query: { id: data.id } });
        } else {
          const route = vm.$router.resolve({ path: targetPath, query: { id: data.id } });
          window.open(route.href, '_blank');
        }
        return
      }

      if (data.type === 'security_self_audit' && data.id) {
        const targetPath = '/risk/security_self_audit/audits';
        if (currentPath === targetPath) {
          vm.$router.push({ path: targetPath, query: { id: data.id } });
        } else {
          const route = vm.$router.resolve({ path: targetPath, query: { id: data.id } });
          window.open(route.href, '_blank');
        }
        return
      }

      if (data.type === 'policy_exception' && data.id) {
        const targetPath = `/policy-exceptions/${data.id}`;
        if (currentPath === targetPath) {
          vm.$router.push({ path: targetPath });
        } else {
          const route = vm.$router.resolve({ path: targetPath });
          window.open(route.href, '_blank');
        }
        return
      }

      if (data.type === 'planning_released_form' && data.entityKind && data.planningRecord) {
        const row = data.planningRecord;
        const unitId = row.id_unit != null ? Number(row.id_unit) : row.unit && row.unit.id != null ? Number(row.unit.id) : null;
        if (unitId == null || !Number.isFinite(unitId) || row.id == null) return;
        const pathByKind = {
          simulacrum: '/risk/simulacrums',
          operational_procedure: '/risk/operational_procedure',
          security_self_audit: '/risk/security_self_audit/audits',
          risk_evaluation: '/risk/evaluations',
        };
        const targetPath = pathByKind[data.entityKind];
        if (!targetPath) return;
        const query = {
          scheduledStart: '1',
          id: String(row.id),
          unitId: String(unitId),
        };
        const refNum = row.reference_number;
        if (refNum) query.reference = String(refNum);
        const lastName = row.last_status && row.last_status.name != null ? String(row.last_status.name).trim() : "";
        if (lastName) query.existingLastStatus = lastName;
        if (currentPath === targetPath) {
          vm.$router.push({ path: targetPath, query });
        } else {
          const route = vm.$router.resolve({ path: targetPath, query });
          window.open(route.href, '_blank');
        }
        return;
      }

      if (data.type === 'planning' && data.id) {
        const targetPath = `/planning/${data.id}`;
        if (currentPath === targetPath) {
          vm.$router.push({ path: targetPath });
        } else {
          const route = vm.$router.resolve({ path: targetPath });
          window.open(route.href, '_blank');
        }
        return
      }

      if (data.type === 'operational_security_form_validation' && data.action_plan) {
        const templateAnswerId = data.action_plan.template_answer_id ?? data.action_plan.formValidationData?.form?.id;
        if (templateAnswerId) {
          const route = vm.$router.resolve({
            path: '/operational_security/form-answers',
            query: { edit: templateAnswerId },
          });
          window.open(route.href, '_blank');
        }
        return
      }

      if ((data.type === 'penetration_testing_validate' || data.type === 'penetration_testing_reopened') && data.id) {
        vm.$router.push({path: '/testing/penetration', query: {id: data.penetration_testing.id}})
        return
      }

      if ((data.type === 'training_validate') || (data.type === 'training_reopened')) {
        vm.$router.push({path: '/training', query: {id: data.training.id}})
        return
      }

      if ((data.type === 'security_box_testing_validate' || data.type === 'security_box_testing_reopened') && data.id) {
        vm.$router.push({path: '/testing/security_box', query: {id: data.security_box_testing.id}})
        return
      }

      if (data.type === 'user_view_validate' || data.type === 'user_view_commented') {
        userViewSelected.value = {
          ...data,
          comments: data.comments
        }

        showModalUserViews.value = true;
        return
      }

      if (data.type === 'user_view_was_validated') {
        userViewSelected.value = {
          ...data
        }

        showUserViewValidatedModal.value = true;
        return
      }

      if (data.type === 'video_tour_validate' || data.type === 'video_tour_commented') {
        videTourSelected.value = {
          ...data,
          comments: data.comments
        }

        showModalVideoTour.value = true;
        return
      }


      if (data.type === 'video_tour_was_validated') {
        videTourSelected.value = {
          ...data
        }

        showVideoTourValidatedModal.value = true;
        return
      }

      if (data.type === 'operational_security_answered_form' || data.type === 'answered_form' || data.type === 'notification-form') {
        const formAnswerId =
          data.id_form_answer ??
          data.form_answer_id ??
          (data.form && data.form.id != null ? data.form.id : null) ??
          data.id_form ??
          data.id;
        if (formAnswerId != null) {
          vm.$router.push({
            path: '/operational_security/form-answers',
            query: { 'open-id': String(formAnswerId), id: String(formAnswerId) },
          });
          return;
        }
      }

      if ((data.type === 'crisis_validate') || (data.type === 'crisis_reopened')) {
        vm.$router.push({name: 'crisis_form_edit', params: { id: data.crisis.id}})
        return
      }

      if ((data.type === 'recording_request_validate') || (data.type === 'recording_request_reopened')) {
        vm.$router.push({name: 'recording_request_edit', params: {id: data.id_request}})
        return
      }


      if (data.route) {
        vm.$router.push(data.route)
        return
      }

      if (!data.action_plan) {
        return;
      }

      const actionPlanData = {
        id_action_plan: data.id_action_plan,
        name: data.action_plan.name || '',
        uuid_action_plan_log: data.uuid_action_plan_log,
      }

      onActionPlanSelected(actionPlanData);
    }

    const handleClick = (data) => {
      if (isDragging.value) return;
      if (Date.now() < suppressClickUntil.value) return;
      openAlarmData(data);
    }

    // Drag to grid
    const onDragStart = (event, data) => {
      isDragging.value = true;
      try {
        if (event && event.dataTransfer) {
          event.dataTransfer.effectAllowed = 'copy';
          event.dataTransfer.dropEffect = 'copy';
          event.dataTransfer.setData('text/plain', 'psim-dnd');
          event.dataTransfer.setData('text', 'psim-dnd');
        }
      } catch (_) {
      }

      if (isPanelFailureNotification(data)) {
        const alarm = data.taskData.alarm;
        if (alarm && alarm.id) {
          store.dispatch('grid/setSlotData', buildPanelFailureSlotData(alarm));
        } else {
          hydratePanelFailureNotification(data).then(() => {
            const resolvedAlarm = data.taskData.alarm;
            if (resolvedAlarm && resolvedAlarm.id) {
              store.dispatch('grid/setSlotData', buildPanelFailureSlotData(resolvedAlarm));
            }
          });
        }
        return
      }

      if (data && data.type === 'risk' && data.id) {
        store.dispatch('grid/setSlotData', {
          type: SLOT_TYPES.RISK_EVALUATION,
          name: vm.$tc ? vm.$tc('risk.evaluation.title', 1) : 'Risk Evaluation',
          data: {evaluation_id: data.id},
          source: SOURCES.MAIN_SEARCH,
        })
        return
      }

      if (data && data.type === 'simulacrum' && data.id) {
        store.dispatch('grid/setSlotData', {
          type: SLOT_TYPES.SIMULACRUM,
          name: vm.$t ? vm.$t('simulacrum.title') : 'Simulacrum',
          data: {simulacrum_id: data.id},
          source: SOURCES.MAIN_SEARCH,
        })
        return
      }

      if (data && data.type === 'operational_procedure' && data.id) {
        store.dispatch('grid/setSlotData', {
          type: SLOT_TYPES.OPERATIONAL_PROCEDURE,
          name: vm.$t ? vm.$t('operational_procedure_exercise.title') : 'Operational Procedure Exercise',
          data: {operational_procedure_id: data.id},
          source: SOURCES.MAIN_SEARCH,
        })
        return
      }
      if (data && data.type === 'security_self_audit' && data.id) {
        store.dispatch('grid/setSlotData', {
          type: SLOT_TYPES.SECURITY_SELF_AUDIT,
          name: vm.$t ? vm.$t('security_self_audit.title') : 'Security Self Audit',
          data: {security_self_audit_id: data.id},
          source: SOURCES.MAIN_SEARCH,
        })
        return
      }
      if (data && (data.type === 'operational_security_form_validation' || data.type === 'significant_event_pending_comment')) {
        store.dispatch('grid/setSlotData', {
          type: SLOT_TYPES.OPERATIONAL_SECURITY_FORM,
          name: data.action_plan.name,
          data: {
            ...data.action_plan,
            source: SOURCES.MAIN_SEARCH
          },
          source: SOURCES.MAIN_SEARCH,
        })
        return
      }

      // Do not navigate on drag for route-based items; drag should only set grid data
      if (data && data.id_action_plan && data.action_plan) {
        const alarm = data.alarm || (data.action_plan.action_plan_logs && data.action_plan.action_plan_logs[0] && data.action_plan.action_plan_logs[0].alarm);

        const actionPlanData = {
          id_action_plan: data.id_action_plan,
          name: data.action_plan.name || '',
          uuid_action_plan_log: data.uuid_action_plan_log,
          alarm
        }

        onActionPlanSelected(actionPlanData);
      }
    }

    const onDragEnd = () => {
      isDragging.value = false;
      suppressClickUntil.value = Date.now() + 300;
      // Do not reset grid slot selection here; the grid drop handler will clear it after applying
    }

    const completePanelFailureNotification = async (notification) => {
      const taskId = notification?.taskId;
      if (!taskId) return;

      try {
        await store.dispatch('unit/updateTaskStatus', {id: taskId, status: 'done'});
        await handleTaskUpdated(taskId);
      } catch (error) {
        console.error('Error completing panel failure task:', error);
      }
    }

    const removeRiskNotification = (data) => {
      notifications.value = notifications.value.filter(n => !(n.type === 'risk' && n.id === data.id));
    }

    const removeSimulacrumNotification = (data) => {
      notifications.value = notifications.value.filter(n => !(n.type === 'simulacrum' && n.id === data.id));
    }

    const removeBauComplementNotification = (data) => {
      notifications.value = notifications.value.filter(n => !(n.type === 'bau_complement' && n.id === data.id));
    }

    const removeOperationalProcedureNotification = (data) => {
      notifications.value = notifications.value.filter(n => !(n.type === 'operational_procedure' && n.id === data.id));
    }

    const removeSecuritySelfAuditNotification = (data) => {
      notifications.value = notifications.value.filter(n => !(n.type === 'security_self_audit' && n.id === data.id));
    }

    const removePolicyExceptionNotification = (data) => {
      notifications.value = notifications.value.filter(n => !(n.type === 'policy_exception' && n.id === data.id));
    }

    const removeAllNotification = () => {
      store.dispatch("grid/removeAllNotificationAlarm");
    }

    const isFinalRisk = (n) => {
      if (!n || n.type !== 'risk') return false;
      const extractStatus = () => {
        const st = String(n.status || '').toLowerCase();
        if (st) return st;
        const text = String(n?.action_plan?.name || '').toLowerCase();
        const finals = ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado'];
        return finals.find(k => text.includes(k)) || '';
      };
      const st = extractStatus();
      return ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado', 'aprovado', 'rejeitado', 'cancelado'].includes(st);
    }

    const isFinalSimulacrum = (n) => {
      if (!n || n.type !== 'simulacrum') return false;
      const extractStatus = () => {
        const st = String(n.status || '').toLowerCase();
        if (st) return st;
        const text = String(n?.action_plan?.name || '').toLowerCase();
        const finals = ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado'];
        return finals.find(k => text.includes(k)) || '';
      };
      const st = extractStatus();
      return ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado', 'aprovado', 'rejeitado', 'cancelado'].includes(st);
    }

    const isFinalBauComplement = (n) => {
      if (!n || n.type !== 'bau_complement') return false;
      const extractStatus = () => {
        const st = String(n.status || '').toLowerCase();
        if (st) return st;
        const text = String(n?.action_plan?.name || '').toLowerCase();
        const finals = ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado'];
        return finals.find(k => text.includes(k)) || '';
      };
      const st = extractStatus();
      return ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado', 'aprovado', 'rejeitado', 'cancelado'].includes(st);
    }

    const isFinalOperationalProcedure = (n) => {
      if (!n || n.type !== 'operational_procedure') return false;
      const extractStatus = () => {
        const st = String(n.status || '').toLowerCase();
        if (st) return st;
        const text = String(n?.action_plan?.name || '').toLowerCase();
        const finals = ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado'];
        return finals.find(k => text.includes(k)) || '';
      };
      const st = extractStatus();
      return ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado', 'aprovado', 'rejeitado', 'cancelado'].includes(st);
    }

    const isFinalSecuritySelfAudit = (n) => {
      if (!n || n.type !== 'security_self_audit') return false;
      const extractStatus = () => {
        const st = String(n.status || '').toLowerCase();
        if (st) return st;
        const text = String(n?.action_plan?.name || '').toLowerCase();
        const finals = ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado'];
        return finals.find(k => text.includes(k)) || '';
      };
      const st = extractStatus();
      return ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado', 'aprovado', 'rejeitado', 'cancelado'].includes(st);
    }

    const isFinalPolicyException = (n) => {
      if (!n || n.type !== 'policy_exception') return false;
      const extractStatus = () => {
        const st = String(n.status || '').toLowerCase();
        if (st) return st;
        const text = String(n?.action_plan?.name || '').toLowerCase();
        const finals = ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado'];
        return finals.find(k => text.includes(k)) || '';
      };
      const st = extractStatus();
      return ['approved', 'rejected', 'canceled', 'cancelled', 'aprobado', 'rechazado', 'cancelado', 'aprovado', 'rejeitado', 'cancelado'].includes(st);
    }

    const getUserViewsForValidate = async (sourceData) => {
      await resolveNotificationRequest(sourceData, () => axios.get('v1/user-views/for-validate'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(userView => {

              notifications.value.unshift({
                ...userView,
                user: userView.user_created,
                type: 'user_view_validate'
              });

            });
          }
        });
    }

    const getUserViewsWithComments = async (sourceData) => {
      await resolveNotificationRequest(sourceData, () => axios.get('v1/user-views/with-comments'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(userView => {
              notifications.value.unshift({
                ...userView,
                user: userView.user_validation,
                type: 'user_view_commented'
              });
            });
          }
        });
    }

    const getVideoToursForValidate = async (sourceData) => {
      await resolveNotificationRequest(sourceData, () => axios.get('v1/video-tours/for-validate'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(videoTour => {
              notifications.value.unshift({
                ...videoTour,
                user: videoTour.user_created,
                type: 'video_tour_validate'
              });

            });
          }
        });
    }

    const getVideoToursWithComments = async (sourceData) => {
      await resolveNotificationRequest(sourceData, () => axios.get('v1/video-tours/with-comments'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(videoTour => {
              notifications.value.unshift({
                ...videoTour,
                user: videoTour.user_validation,
                type: 'video_tour_commented'
              });
            });
          }
        });
    }

    const removeUserViewNotification = (userViewId = null) => {
      const idUserView = (userViewId) ? userViewId : userViewData.value.id;

      const indexUserViewNotification = notifications.value.findIndex(
        notification => (notification.type === 'user_view_validate' || notification.type === 'user_view_commented' || notification.type === 'video_tour_validate' || notification.type === 'video_tour_commented') && (notification.id === idUserView)
      );

      if (indexUserViewNotification !== -1) {
        notifications.value.splice(indexUserViewNotification, 1);
      }
    }

    const getAvatarNotificaction = (notification) => {
      if (notification.type === 'user_view_validate' || notification.type === 'user_view_commented' || notification.type === 'user_view_was_validated') {
        return 'VU';
      } else if (notification.type === 'video_tour_validate' || notification.type === 'video_tour_commented' || notification.type === 'video_tour_was_validated') {
        return 'VT';
      }else if (notification.type === 'penetration_testing_validate' || notification.type === 'penetration_testing_reopened') {
        return 'PP'
      } else if (notification.type === 'security_box_testing_validate' || notification.type === 'security_box_testing_reopened') {
        return 'PC'
      } else if (notification.type === 'planning_released_form') {
        return 'PR'
      } else if (notification.type === 'policy_exception') {
        return 'EP'
      } else if (notification.type === 'crisis_validate' || notification.type === 'crisis_reopened') {
        return 'FC'
      } else if (notification.type === 'recording_request_validate' || notification.type === 'recording_request_reopened') {
        return 'PG'
      }

      return notification.name;
    }

    const openViewModal = () => {
      userViewData.value = {
        id: userViewSelected.value.user_view.id,
        data: userViewSelected.value.data,
        id_user_validation: userViewSelected.value.id_user_validation,
        id_user: userViewSelected.value.user_view.id_user,
        is_camera_view: true,
        is_public: (userViewSelected.value.user_view.id_user) ? true : false,
        layout_id: userViewSelected.value.data.layout,
        name: userViewSelected.value.user_view.name,
        validations: userViewSelected.value.user_view.validations,
        coordinates: userViewSelected.value.user_view.coordinates,
        lastStatus: userViewSelected.value.user_view.last_status
      }

      showViewModal.value = true;
    }

    const openVideoTourModal = () => {
      userVideoTourData.value = {
        id: videTourSelected.value.video_tour.id,
        config: videTourSelected.value.config,
        id_user_validation: videTourSelected.value.id_user_validation,
        id_user_created: videTourSelected.value.id_user_created,
        id_tenant: videTourSelected.value.video_tour.id_tenant,
        name: videTourSelected.value.video_tour.name,
        validations: videTourSelected.value.video_tour.validations,
        views: videTourSelected.value.video_tour.views,
        comments: videTourSelected.value.comments
      }

      nextTick(() => {
        showModalVideoTour.value = false;
        videoTourModalForm.value.$bvModal.show('videoTourModal');
      });
    }

    const setCurrentPreview = (value) => {
      currentPreviewSelected.value = value;
    }

    const refreshUserViews = async (data) => {
      const params = {
        max: 4,
        currentPage: 1
      }

      await store.dispatch("grid/getUserViews", params);

      notifications.value.unshift({
        ...data.userView,
        user: data.userView.user_validation,
        type: 'user_view_was_validated'
      });
    }

    const closeUserViewValidatedModal = () => {
      const indexNotificaction = notifications.value.findIndex(
        notificacion => (notificacion.type === 'user_view_was_validated') && (notificacion.id === userViewSelected.value.id)
      );

      notifications.value.splice(indexNotificaction, 1);
      showUserViewValidatedModal.value = false;
    }

    const refreshVideoTours = (data) => {
      notifications.value.unshift({
        ...data.videoTour,
        user: data.videoTour.user_validation,
        type: 'video_tour_was_validated'
      });

      EventBus.emit('video-tour-was-validated');
    }

    const closeVideoTourValidatedModal = () => {
      const indexNotificaction = notifications.value.findIndex(
        notificacion => (notificacion.type === 'video_tour_was_validated') && (notificacion.id === userViewSelected.value.id)
      );

      notifications.value.splice(indexNotificaction, 1);
      showVideoTourValidatedModal.value = false;
    }

    const getPenetrationTestingForValidate = async (sourceData) => {
       await resolveNotificationRequest(sourceData, () => axios.get('v1/testing/penetration/for-validate'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(penetrationTestingStatus => {
              notifications.value.unshift({
                ...penetrationTestingStatus,
                user: penetrationTestingStatus.user,
                type: 'penetration_testing_validate'
              });

            });
          }
        });
    }

    const getPenetrationTestingReopened = async (sourceData) => {
       await resolveNotificationRequest(sourceData, () => axios.get('v1/testing/penetration/reopened'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(penetrationTestingStatus => {
              notifications.value.unshift({
                ...penetrationTestingStatus,
                user: penetrationTestingStatus.user,
                type: 'penetration_testing_reopened'
              });

            });
          }
        });
    }

    const getSecurityBoxTestingForValidate = async (sourceData) => {
       await resolveNotificationRequest(sourceData, () => axios.get('v1/testing/security-box/for-validate'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(securityBoxTestingStatus => {
              notifications.value.unshift({
                ...securityBoxTestingStatus,
                user: securityBoxTestingStatus.user,
                type: 'security_box_testing_validate'
              });

            });
          }
        });
    }

    const getSecurityBoxTestingReopened = async (sourceData) => {
       await resolveNotificationRequest(sourceData, () => axios.get('v1/testing/security-box/reopened'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(penetrationTestingStatus => {
              notifications.value.unshift({
                ...penetrationTestingStatus,
                user: penetrationTestingStatus.user,
                type: 'security_box_testing_reopened'
              });

            });
          }
        });
    }

    const removeTestingNotification = (data) => {
      const { id,type } = data;
      const indexNotificaction = notifications.value.findIndex(
        notificacion => (notificacion.type === type) && (notificacion.id === id)
      );

      notifications.value.splice(indexNotificaction, 1)
    }

    const getTrainingsForValidate = async (sourceData) => {
       await resolveNotificationRequest(sourceData, () => axios.get('v1/trainings/for-validate'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(trainingValidations => {
              notifications.value.unshift({
                ...trainingValidations,
                user: trainingValidations.user,
                type: 'training_validate'
              });

            });
          }
        });
    }

    const getTrainingsReopened = async (sourceData) => {
       await resolveNotificationRequest(sourceData, () => axios.get('v1/trainings/reopened'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(trainingValidations => {
              notifications.value.unshift({
                ...trainingValidations,
                user: trainingValidations.user,
                type: 'training_reopened'
              });

            });
          }
        });
    }

    const removeTrainingNotification = (data) => {
      const { id,type } = data;
      const indexNotificaction = notifications.value.findIndex(
        notificacion => (notificacion.type === type) && (notificacion.id === id)
      );

      notifications.value.splice(indexNotificaction, 1)
    }

    const getCrisisReopened = async (sourceData) => {
       await resolveNotificationRequest(sourceData, () => axios.get('v1/operational-security-crisis/reopened'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(crisis => {
              notifications.value.unshift({
                ...crisis,
                user: crisis.user,
                type: 'crisis_reopened'
              });

            });
          }
        });
    }

    const getCrisisForValidate = async (sourceData) => {
       await resolveNotificationRequest(sourceData, () => axios.get('v1/operational-security-crisis/for-validate'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(crisis => {
              notifications.value.unshift({
                ...crisis,
                user: crisis.user,
                type: 'crisis_validate'
              });

            });
          }
        });
    }

    const getRecordingRequestReopened = async (sourceData) => {
       await resolveNotificationRequest(sourceData, () => axios.get('v1/recording_request/reopened'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(recordindRequestValidation => {
              notifications.value.unshift({
                ...recordindRequestValidation,
                user: recordindRequestValidation.user,
                type: 'recording_request_reopened'
              });
            });
          }
        });
    }

    const getRecordingRequestForValidate = async (sourceData) => {
      await resolveNotificationRequest(sourceData, () => axios.get('v1/recording_request/for-validate'))
        .then(response => {
          const { data } = response;

          if (data.data.length) {
            data.data.forEach(recordindRequestValidation => {
              notifications.value.unshift({
                ...recordindRequestValidation,
                user: recordindRequestValidation.user,
                type: 'recording_request_validate'
              });
            });
          }
        });
    }

    const removeNotificationByType = (data) => {
      const { id,type } = data;
      const indexNotificaction = notifications.value.findIndex(
        notificacion => (notificacion.type === type) && (notificacion.id === id)
      );

      notifications.value.splice(indexNotificaction, 1)
    }

    const dateFormatedSecurityBox = (date) => {
      return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    // Significant Events Pending Comments
    const fetchSignificantEventsPendingComments = async (sourceData) => {
      try {
        const {data} = await resolveNotificationRequest(
          sourceData,
          () => axios.get('/v1/operational-security-forms/significant-events/pending-comments'),
        );

        const list = Array.isArray(data?.data) ? data.data : [];

        const significantEventsNotifications = list.map(ev => ({
          id: ev.id,
          type: 'significant_event_pending_comment',
          name: 'ER',
          action_plan: {
            name: vm.$t ? vm.$t('operational_security.significant_event_pending_comments') : 'Significant event pending comment',
            reference: ev.form_answer?.template,
            template_answer_id: ev.form_answer?.id,
            formValidationData: {...ev, status_date: moment(ev.created_at).format('DD/MM/YYYY HH:mm:ss'), form: {
              id: ev.form_answer?.id,
            }},
            formValidation: true,
          },
          user: {user: ev?.user_validator?.full_name || '-'},
          status: ev?.status,
          occurred_at: ev?.updated_at || ev?.created_at || null,
        }));

        const currentNotifications = notifications.value.filter(n => n.type !== 'significant_event_pending_comment');

        notifications.value = [...significantEventsNotifications, ...currentNotifications];

      } catch (error) {
        console.error('Error fetching op security form validations:', error);
      }
    }

    const externalPersonnelReminderEvent = data => {
      const eventData = {
        name: 'DM',
        type: 'external_personnel_reminder',
        device_name: data.device_name,
        device_proxy_id: data.device_proxy_id,
        external_personnel_access_control_id: data.external_personnel_access_control_id,
      }

      notifications.value = [
        eventData,
        ...notifications.value,
      ];
    }

    const goToExternalPersonnelAccessControlView = (notification) => {
      notifications.value = notifications.value.filter(n => n?.external_personnel_access_control_id !== notification.external_personnel_access_control_id);

      vm.$router.push({
        path: '/operational_security/external_personnel_access_control',
        query: {
          id: notification.external_personnel_access_control_id,
          device_proxy_id: notification.device_proxy_id,
        },
      });
    }

    return {
      notifications,
      filteredNotifications,
      selectedTask,
      loading,
      perfectScrollbarSettings,

      openAlarmData,
      openTaskAlarm,
      handleClick,
      handleTaskUpdated,
      onDragStart,
      onDragEnd,
      isPanelFailureNotification,
      completePanelFailureNotification,
      removeRiskNotification,
      removeSimulacrumNotification,
      removeBauComplementNotification,
      removePolicyExceptionNotification,
      removeOperationalProcedureNotification,
      removeSecuritySelfAuditNotification,
      removeAllNotification,
      isFinalRisk,
      isFinalSimulacrum,
      isFinalBauComplement,
      isFinalPolicyException,
      isFinalOperationalProcedure,
      isFinalSecuritySelfAudit,
      calculateDaysDifference,
      getDeadlineTooltip,
      formatDeadlineDate,
      getDeadlineText,
      getDeadlineIconClass,
      getNotificationDeadline,
      getActionPlanName,
      getUserViewsForValidate,
      getAvatarNotificaction,
      getVideoToursForValidate,
      getVideoToursWithComments,
      showModalUserViews,
      showViewModal,
      userViewSelected,
      removeUserViewNotification,
      getUserViewsWithComments,
      openViewModal,
      currentPreviewSelected,
      setCurrentPreview,
      userViewData,
      videTourSelected,
      showModalVideoTour,
      openVideoTourModal,
      videoTourModalForm,
      userVideoTourData,
      showUserViewValidatedModal,
      closeUserViewValidatedModal,
      showVideoTourValidatedModal,
      refreshVideoTours,
      closeVideoTourValidatedModal,
      removeTestingNotification,
      removeTrainingNotification,
      dateFormatedSecurityBox,
      removeNotificationByType,
      externalPersonnelReminderEvent,
      goToExternalPersonnelAccessControlView
    };
  },
};
</script>

<style scoped>
.deadline-container {
  max-width: 100%;
}

.deadline-badge {
  cursor: pointer;
  padding: 0.4rem 0.6rem;
  font-size: 0.8rem;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  color: #1b3d5e !important;
}

.deadline-icon {
  margin-top: 2px;
  margin-right: 8px;
}

/* Asegurar que los colores de advertencia y peligro se apliquen correctamente */
.deadline-badge .text-danger,
.deadline-badge .text-danger .deadline-icon,
.deadline-badge .text-danger svg,
.deadline-badge .text-danger .deadline-icon svg {
  color: #ea5455 !important;
  fill: #ea5455 !important;
  stroke: #ea5455 !important;
}

.deadline-badge .text-warning,
.deadline-badge .text-warning .deadline-icon,
.deadline-badge .text-warning svg,
.deadline-badge .text-warning .deadline-icon svg {
  color: #ff9f43 !important;
  fill: #ff9f43 !important;
  stroke: #ff9f43 !important;
}

.dark-layout .deadline-badge {
  background-color: rgb(74, 112, 141);
  color: #d8d8d8 !important;
}

.dark-layout .deadline-badge .deadline-icon {
  color: #d8d8d8 !important;
}

.dark-layout .deadline-badge .text-danger,
.dark-layout .deadline-badge .text-danger .deadline-icon,
.dark-layout .deadline-badge .text-danger svg,
.dark-layout .deadline-badge .text-danger .deadline-icon svg {
  color: #ea5455 !important;
  fill: #ea5455 !important;
  stroke: #ea5455 !important;
}

.dark-layout .deadline-badge .text-warning,
.dark-layout .deadline-badge .text-warning .deadline-icon,
.dark-layout .deadline-badge .text-warning svg,
.dark-layout .deadline-badge .text-warning .deadline-icon svg {
  color: #ff9f43 !important;
  fill: #ff9f43 !important;
  stroke: #ff9f43 !important;
}
</style>
